import CheckBoxCustom from '../../../../atoms/checkbox/CheckBox'
import InputCustom from '../../../../atoms/input/InputCustom'
import TextArea from '../../../../atoms/textarea/TextArea'
import { Grid, Typography } from '@mui/material'
import { useState } from 'react'
import styles from '../index.module.scss'

const ReceptionModal = () => {
	const [receptionData, setReceptionData] = useState({})
	return (
		<>
			<div className={styles.header}>
				<h3>Reception & Entertainment</h3>
			</div>

			<div className={`${styles.formWrp} ${styles.receptionForm}`}>
				<Grid container spacing={1.5}>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="surpriseElements"
								className={styles.label}
							>
								Surprise Elements or Reveals
							</label>
							<TextArea
								placeholder="Describe any surprise elements planned"
								value={receptionData.surpriseElements}
								onChange={(e) =>
									setReceptionData({
										...receptionData,
										surpriseElements: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.checkFormField}>
							<Typography variant="h4">Grand Entrance</Typography>
							<ul>
								<li>
									<CheckBoxCustom
										name="JustTheCouple"
										id="JustTheCouple"
										lineColor="#ffffffb0"
										label={
											<span
												style={{
													marginTop: '2px',
													display: 'inline-block',
												}}
											>
												Just the couple
											</span>
										}
										value={receptionData.justTheCouple}
										onChange={(e) =>
											setReceptionData({
												...receptionData,
												justTheCouple: e.target.value,
											})
										}
									/>
								</li>
								<li>
									<CheckBoxCustom
										name="BridesmaidsGroomsmenIncluded"
										id="BridesmaidsGroomsmenIncluded"
										lineColor="#ffffffb0"
										label={
											<span>
												Bridesmaids/groomsmen included
											</span>
										}
										value={
											receptionData.bridesmaidsGroomsmenIncluded
										}
										onChange={(e) =>
											setReceptionData({
												...receptionData,
												bridesmaidsGroomsmenIncluded:
													e.target.value,
											})
										}
									/>
								</li>
							</ul>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyDuration"
								className={styles.label}
							>
								Ceremony Duration (estimated)
							</label>
							<InputCustom
								type="text"
								name="ceremonyDuration"
								id="ceremonyDuration"
								placeholder="e.g., 30 minutes"
								value={receptionData.ceremonyDuration}
								onChange={(e) =>
									setReceptionData({
										...receptionData,
										ceremonyDuration: e.target.value,
									})
								}
							/>
						</div>
					</Grid>

					<Grid size={{ xs: 12, md: 12 }}>
						<Typography variant="h4" className={styles.fieldTitle}>
							Entertainment Elements
						</Typography>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfEntertainmentElements"
								className={styles.label}
							>
								Number of Entertainment Elements
							</label>
							<InputCustom
								type="text"
								name="numberOfEntertainmentElements"
								id="numberOfEntertainmentElements"
								placeholder="3"
								value={
									receptionData.numberOfEntertainmentElements
								}
								onChange={(e) =>
									setReceptionData({
										...receptionData,
										numberOfEntertainmentElements:
											e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="EstimatedDuration"
								className={styles.label}
							>
								Estimated Duration
							</label>
							<InputCustom
								type="text"
								name="EstimatedDuration"
								id="EstimatedDuration"
								placeholder="e.g., 30 minutes each"
								value={receptionData.EstimatedDuration}
								onChange={(e) =>
									setReceptionData({
										...receptionData,
										EstimatedDuration: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default ReceptionModal
